import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";

type Props = {
  url: string;
  additionalClassName?: string;
  disabled?: boolean;
  label?: string;
};

function ViewLink({ url, disabled, label, additionalClassName }: Props) {
  return (
    <Link
      className={classNames("table-shared-view-button", additionalClassName, {
        disabled,
      })}
      to={url}
    >
      {label}
    </Link>
  );
}

ViewLink.defaultProps = {
  disabled: false,
  label: "View",
  additionalClassName: null,
};

export default ViewLink;
